import { render, staticRenderFns } from "./DashboardAnalyticsBookingTemplateBox.vue?vue&type=template&id=1b46b82c"
import script from "./DashboardAnalyticsBookingTemplateBox.vue?vue&type=script&lang=js"
export * from "./DashboardAnalyticsBookingTemplateBox.vue?vue&type=script&lang=js"
import style0 from "./DashboardAnalyticsBookingTemplateBox.vue?vue&type=style&index=0&id=1b46b82c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports